/* 每日热点 */
import React, { useState } from 'react'
import get from 'lodash/get'

import Header from './header'

import ArticleLink from 'Components/links/article-link'

import { sendTeaCommEvent } from 'lib/tea-analyze'
import applyHttpsImage from 'lib/apply-https-img'

interface IProps {
  hotSpot: any
}

interface HotSpotData {
  gid_str: string
  is_video: boolean
  title: string
  abstract: string
}

export default function HotSpot({ hotSpot }: IProps) {
  /* 当前hover的标题 */
  const [currentIndex, setCurrentIndex] = useState(0)

  function renderList(data: HotSpotData, index: number) {
    return (
      <div className="article" key={data.title}>
        <ArticleLink
          gid={data.gid_str}
          isVideo={data.is_video}
          onClick={(gid: string) => {
            sendTeaCommEvent('click_everyday_hot_topic', {
              group_id: gid,
              rank: index,
            })
          }}
        >
          <p
            onMouseEnter={() => {
              setCurrentIndex(index)
            }}
          >
            {data.title}
          </p>
          {currentIndex === index && (
            <div className="detail clearfix">
              {get(data, 'cover_url', '') !== '' && (
                <img
                  className="cover fl"
                  src={applyHttpsImage(get(data, 'cover_url', ''))}
                  alt=""
                />
              )}

              <div
                className={`text fl line-3 ${
                  get(data, 'cover_url', '') !== '' ? '' : 'no-img'
                }`}
              >
                {data?.abstract || ''}
              </div>
            </div>
          )}
        </ArticleLink>
        <style jsx>
          {`
            .article {
              padding: 16px 0;
              border-bottom: 1px solid #ededed;
            }
            .article:last-child {
              border-bottom: 0;
            }
            .article:hover {
              color: #406599;
              cursor: pointer;
              transition: color 0.3s ease-out;
            }
            p {
              position: relative;
            }
            p::before {
              content: '';
              position: absolute;
              top: 9px;
              left: -12px;
              display: inline-block;
              width: 4px;
              height: 4px;
              border-radius: 50%;
              background-color: #d8d8d8;
            }
            .detail {
              margin-top: 8px;
              opacity: 0;
              animation: fade 0.3s ease-in-out forwards;
            }
            @keyframes fade {
              from {
                opacity: 0;
              }
              to {
                opacity: 1;
              }
            }
            .cover {
              width: 91px;
              height: 60px;
              margin-right: 12px;
            }
            .text {
              width: 237px;
              height: 61px;
              font-size: 14px;
              color: #999;
            }

            .no-img {
              width: auto;
            }
          `}
        </style>
      </div>
    )
  }

  return (
    <div className="hotspot">
      <Header leftContent="实时热点" rightContent={obtainData()} />
      <div className="list">
        {hotSpot
          .slice(0, 4)
          .map((item: HotSpotData, index: number) => renderList(item, index))}
      </div>
      <style jsx>
        {`
          .hotspot {
            margin-bottom: 10px;
            border: 1px solid #e6e6e6;
          }
          .list {
            margin: 0 24px;
            font-size: 16px;
          }
        `}
      </style>
    </div>
  )
}

/* 获取今天日期 */
function obtainData() {
  const date = new Date()
  return `${date.getMonth() + 1}月${date.getDate()}日`
}
